/**
 * ILink zum wecheln von der Web-Seite zum CMS.
 * @class SP.sitekit.ILink
 */
SP.lang.Class.define("SP.sitekit.ILink", {

	singleton: true,

	_el: null,

	_config: null,

	_session: null,

	_connectionState: null,

	_notice: null,

	_noticeTimer: null,


	/**
	 * Konstruktor
	 *
	 * @private
	 * @construct SP.sitekit.ILink
	 */
	init: function() {

		var me = this;

		SP.dom.Document.onReady(function() {

			var config = me.getConfig();
			if (!config) {
				return;
			}

			me._module = SP.net.Cookie.getCookie("ies_module_");
			me._language = SP.net.Cookie.getCookie("ies_language_");

			if (config.url) {
				var button = me._el.querySelector(".SP-Ilink__button");
				if (button) {
					button.addEventListener("click", function(e) {
						me.open();
					});
				}

				me._connect();
			} else {
				console.error("ilink disabled, no cms-url in config", config);
			}
		});
	},


	_openSession: function (connection) {
		var me = this;
		var sessionId = SP.net.Cookie.getCookie("ilink.IES.ClientSession.id");
		if (sessionId) {
			var handleSessionTimeout = function (error) {
				if (error instanceof SP.lang.Exception) {
					var errorInfo = error.getError();
					if (errorInfo.getKey() === "core.login") {
						// Session-Timeout
						return me.createNewSession(connection);
					}
				}
				throw error;
			};
			return connection.login(sessionId).catch(handleSessionTimeout);
		}
		return me.createNewSession(connection);
	},

	_connect: function () {
		var me = this;
		var config = me.getConfig();

		IES.Connection.connect({
			uri: config.url,
			connectionOptions: {
				withCredentials: config.withCredentials,
				cors: true
			}
		})
		.then(me._openSession.bind(me))
		.then(me._setSession.bind(me))
		.catch(function (error) {
			me.setConnectionState({
				connected: false,
				error: error
			});
		});
	},

	/**
	 * Öffnet den Artikel der Seiten in Infosite6 oder anderen Applikationen, um ihn zu bearbeiten.
	 */
	open: function() {
		var config = this.getConfig();
		if (config.application === "infosite6") {
			this._openInfosite6(config.module === config.application);
		} else if (config.application === "citygov") {
			this._openCityGov(config.module === config.application);
		}
	},

	_openInfosite6: function(applicationIsOpen) {

		if (!applicationIsOpen) {
			// TODO: Wie soll reagiert werden, wenn Website z.B. über CityGov geöffnet wurde und dann der I-Link
			// für eine Infosite6-Seite geklickt wird?
			return;
		}
		//var me = this;
		if (this.connectionState.connected) {
			var config = this.getConfig();

			var me = this;
			if (me._notice === null) {
				me._notice = document.createElement("div");
				me._notice.setAttribute("class", "SP-Ilink__notice");
				document.body.appendChild(me._notice);
			}

			this.getSession().getRepository()
				.open(null, config.id, 0, null, { session: config.session })
				.then(function () {
					if (me._language === "de") {
						me._notice.innerHTML = "Der Artikel wird in Ihrem InfoSite&nbsp;6-Fenster geöffnet.";
					} else {
						me._notice.innerHTML = "Article will be opened in your InfoSite&nbsp;6 window.";
					}
					SP.dom.Element.addClass(me._notice, "SP-open");
					clearTimeout(me._noticeTimer);
					me._noticeTimer = setTimeout(function () {
						SP.dom.Element.removeClass(me._notice, "SP-open");
					}, 3000);
				});

		}
	},

	_openCityGov: function (applicationIsOpen) {

		/* TODO: Wenn CityGov Seiten fertig sind, damit man auch testen kann.
		var me = this;
		if (me.getWindowId() < 0) {
			return;
		}
		var windowId = "new";
		if (applicationIsOpen) {
			windowId = me.getWindowId();
		}
		var p = [
			"SYS_handler=com.sitepark.ies.control.jsp.handler.LoginHandler",
			"SYS_LGIN_action=login",
			"SYS_window=" + windowId,
			"SYS_LGIN_session=" + me.getSessionId(),
			"infositeWindowId=" + me.getWindowId(),
			"timestamp=" + me.getTime(),
			"_openPool=" + me.attr.parent,
			"_currentSnippetID=0",
			"_currentPoolID=" + me.attr.parent
		];
		p = p.join(";");

		var config = me.getConfig();


		var url = config.url + '/ies/module/city-gov/control/manager?' + p;

		if (me.attr.isCityGovPool) {
			url += ";" +
				"_currentElementID=" + config.id,
				"_currentModule=" + me.attr.cityGovPoolModule;
		} else {
			url += ";" +
				"_currentElementID=" + me.attr.id,
				"_currentStep=0",
				"_currentModule=" + me.attr.cityGovElementModule;
		}

		url += '#a' + me.getIdWithoutType(me.attr.parent);

		var target = (window.isIE ? 'ilink' : '');
		target += me.getIdWithoutType(me.attr.client);
		target += windowId;

		var link = '<div><a href="' + url + '" target="' + target + '"';
		link += ' class="ilink SP-Ilink"';
		link += ' onclick="var cmsWindow = window.open(this.href, this.target); cmsWindow.focus(); return false;">';
		link += me.attr.linkContent;
		link += '</a></div>';

		return link;
		*/
	},

	/**
	 * @return {String}
	 */
	getWindowId: function() {
		// window.name = "ilink_sessionId_windowId_randomNumber4digits"
		var s = window.name.split("_");
		if (s.length === 4) {
			return s[2];
		} else {
			return -1;
		}
	},

	/**
	 * Erzeugt eine neue Session auf Basis der Session-ID in dem Config-Objekt.
	 * Es kann nicht direkt die Session aus dem Config-Objekt verwendet werden da es pro Session-ID
	 * nur eine Verbindung zum Event-Bus geben kann.
	 */
	createNewSession: function(connection) {

		var me = this;

		var config = me.getConfig();

		return connection.login(config.session)
			.then(function (baseSession) {
				return baseSession.cloneSession("ilink");
			});
	},

	/**
	 * Setzt die Session
	 * @private
	 */
	_setSession: function(session) {

		var me = this;

		var config = me.getConfig();
		var eventBus, id;

		SP.net.Cookie.setCookie("ilink.IES.ClientSession.id", session.getId());

		try {
			me._session = session;
			eventBus = session.getSpooledEventBus();
			id = IES.Types.wrapSignature(config.client, config.id, "1000");
		} catch (e) {
			console.error(e);
			console.error(e.stack);
		}

		me.setConnectionState({
			connected: true
		});

/*
		eventBus.addEventListener("eventbusReconnect", function(eventBus) {
			me.setConnectionState({
				connected: true
			});
		});

		eventBus.addEventListener("eventbusTemporaryTerminated", function(eventBus, key, params) {
			me.setConnectionState({
				connected: false,
				reason: {
					key: key,
					params: params
				}
			});
		});

		eventBus.addEventListener("eventbusTerminated", function(eventBus, key, params) {
			if (key === "core.sessionExpired") {
				me.createNewSession(me.getSession().getConnection());
			} else {
				me.setConnectionState({
					connected: false,
					reason: {
						key: key,
						params: params
					}
				});
			}
		});

*/
		eventBus.subscribe([
				{
					event: IES.admin.module.events.InjectEvent,
					handler: function(event) {
						if (window.location.pathname === event.publication.path && me._session.getUser().data[0].id === event.target.user.id) {
							window.location.reload(true);
						}
					},
					scope: this
				},
				{
					event: IES.publish.events.PublishEvent,
					entities: [id],
					handler: function(event) {
						if (window.location.pathname === event.publication.path && me._session.getUser().data[0].id === event.target.user.id) {
							window.location.reload(true);
						}
					},
					scope: this
				}
			],
			function() {
				me.setConnectionState({
					connected: true
				});
			},
			me // scope
		);
	},

	/**
	 * Liefert die Aktuelle Session
	 *
	 * @return string
	 */
	getSession: function() {
		return this._session;
	},

	/**
	 * Liefert die I-Link Konfiguration
	 *
	 * @return Object
	 */
	getConfig: function() {

		var me = this;

		if (me._config === null) {
			var list = document.querySelectorAll("[data-ilink]");
			if (list && list.length > 0) {
				for (var i = 0; i < list.length; i++) {
					me._config = list[i].getAttribute("data-ilink");
					if (me._config) {
						try {
							me._config = JSON.parse(me._config);
							me._el = list[i];
							break;
						} catch (e) {
							me._config = {};
							console.error(e);
						}
					} else {
						me._config = {};
					}
				}
			}
		}

		return me._config;
	},

	/**
	 * Setzt den aktuellen Verbindungs-Status
	 * @private
	 */
	setConnectionState: function(connectionState) {
		this.connectionState = connectionState;
		var stateEl = this._el;
		if (stateEl) {
			if (connectionState.connected) {
				SP.dom.Element.addClass(stateEl, "SP-Ilink-connected");
				SP.dom.Element.removeClass(stateEl, "SP-Ilink-disconnected");
			} else {
				SP.dom.Element.addClass(stateEl, "SP-Ilink-disconnected");
				SP.dom.Element.removeClass(stateEl, "SP-Ilink-connected");
			}
		}
	},

	/**
	 * Liefert den aktuellen Verbindungs-Status
	 * @return Object
	 */
	getConnectionState: function() {
		return this.connectionState;
	}
});
